import React from 'react';

import { type SportId } from '../../../../../types/sports';
import { LineUpF1IconSvg, LineUpIconSvg } from '../../../assets/svg';
import { LineUpSportsWithStopWatchIcon } from '../../../constants/ui';

type LineUpIconPropsType = {
  className?: string;
  sportId: SportId;
};

const LineUpIcon = ({ className = '', sportId }: LineUpIconPropsType) => {
  if (LineUpSportsWithStopWatchIcon.indexOf(sportId) !== -1) {
    return <LineUpF1IconSvg className={className} />;
  }
  return <LineUpIconSvg className={className} />;
};

export default LineUpIcon;
